/**
 * Generates a string signature based on object properties
 * @param {Object} object
 * @returns {string|null}
 */
export default function getObjectSignature(object = {}) {
    if (typeof object !== "object" || Array.isArray(object)) {
        return null;
    }

    const objectPrototype = Object.getPrototypeOf(object);

    return Object.getOwnPropertyNames(objectPrototype).sort()
        .join(":");
}
